// extracted by mini-css-extract-plugin
export default {"bodySmall":"Typography_bodySmall__4pt+6","body":"Typography_body__Q0cks","code":"Typography_code__-PCtV"};